import { useState } from 'react';
import { Button } from '@/components/ui/Button';
import { ConfirmDialog } from './ConfirmDialog';

export interface DeleteProfileActionProps {
  label: string;
  confirmTitle: string;
  confirmBody: string;
  confirmLabel: string;
  isDeleting: boolean;
  /**
   * Runs the delete. The mutation reports its own outcome; on success the page
   * falls back to the setup prompt, which unmounts this dialog with it.
   */
  onDelete: () => void;
  /** `end` = right-aligned at the foot of the page; `start` = left, at the foot of a card. */
  align?: 'start' | 'end';
}

/**
 * "Delete Profile" at the foot of an investor or partner profile page, behind
 * a confirm (US-042, FR-177). Moved out of the old edit-mode forms by MYN-217,
 * since the page no longer has a single edit mode.
 */
export function DeleteProfileAction({
  label,
  confirmTitle,
  confirmBody,
  confirmLabel,
  isDeleting,
  onDelete,
  align = 'end',
}: DeleteProfileActionProps) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className={`flex ${align === 'end' ? 'justify-end' : 'justify-start'}`}>
      <Button variant="linkDanger" onClick={() => setIsOpen(true)}>
        {label}
      </Button>
      <ConfirmDialog
        open={isOpen}
        onOpenChange={setIsOpen}
        title={confirmTitle}
        description={confirmBody}
        confirmLabel={confirmLabel}
        confirmVariant="danger"
        onConfirm={onDelete}
        isConfirming={isDeleting}
      />
    </div>
  );
}
